import React, { useReducer, useEffect } from "react";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import MembershipDetailsForm from "../../Membership/Forms/MembershipDetailsForm/MembershipDetailsForm";
import MembershipProducts from "../../Membership/Forms/MembershipDetailsForm/MembershipProducts";
import AdditionalServices from "../../Membership/Forms/MembershipDetailsForm/AdditionalServices";
import LoadingOverlay from "react-loading-overlay";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { MdArrowDropDownCircle } from "react-icons/md";
import ErrorFooter from "../../../components/ErrorFooter/ErrorFooter";
import "../../../components/ErrorFooter/ErrorFooter.css";

import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { request, handleErrors } from "../../../services/helpers";

// this component and all it's children assumes you are working with `react-hook-form`
// form library. Will crash without using the library.

const SET_ORGANISATION = "SET_ORGANISATION";
const SET_FORM_LOADING = "SET_FORM_LOADING";

// const FORM_DATA_REQUEST = "FORM_DATA_REQUEST";
const FORM_DATA_SUCCESS = "FORM_DATA_SUCCESS";
const FORM_DATA_FAILURE = "FORM_DATA_FAILURE";

// const GET_ORGANISATION_REQUEST = "GET_ORGANISATION_REQUEST";
const GET_ALL_ORGANISATIONS_SUCCESS = "GET_ALL_ORGANISATIONS_SUCCESS";
const GET_ALL_ORGANISATIONS_FAILURE = "GET_ALL_ORGANISATIONS_FAILURE";

const FORM_SUBMIT_SUCCESS = "FORM_SUBMIT_SUCCESS";
const FORM_SUBMIT_FAILURE = "FORM_SUBMIT_FAILURE";

const initialState = {
  organisation: null,
  organisations: [],
  locations: [],
  additionalServices: [],
  membershipTypes: [],
  loading: false,
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_LOADING:
      return {
        ...state,
        loading: action.payload === false ? action.payload : true,
      };
    case SET_ORGANISATION:
      return {
        ...state,
        organisation: action.payload,
      };
    case GET_ALL_ORGANISATIONS_SUCCESS: {
      return {
        ...state,
        organisations: action.payload,
        loading: false,
      };
    }
    case GET_ALL_ORGANISATIONS_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    case FORM_DATA_SUCCESS: {
      return {
        ...state,
        locations: action.payload.locations,
        additionalServices: action.payload.additionalServices,
        membershipTypes: action.payload.membershipTypes,
        loading: false,
      };
    }

    case FORM_DATA_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case FORM_SUBMIT_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case FORM_SUBMIT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

const getInitialFormData = () => {
  let promiseArray = [];
  promiseArray.push(request.get("/buildings"));
  promiseArray.push(request.get("/products/additionalService"));
  promiseArray.push(request.get("/products/membership"));
  return promiseArray;
};

const AddMembership = () => {
  const { watch, handleSubmit } = useFormContext();

  const [formState, dispatch] = useReducer(reducer, initialState);

  const history = useHistory();
  const { error, loading, organisation, organisations } = formState;
  const membershipType = watch("type");

  const getLocations = async () => {
    try {
      // load locations and additional services
      const data = await Promise.all(getInitialFormData());
      dispatch({
        type: FORM_DATA_SUCCESS,
        payload: {
          locations: data[0].data,
          additionalServices: data[1].data,
          membershipTypes: data[2].data,
        },
      });
    } catch (e) {
      dispatch({
        type: FORM_DATA_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  useEffect(() => {
    let active = true;
    (async () => {
      dispatch({ type: SET_FORM_LOADING });
      try {
        // throw new Error("help");
        const res = await request.get("/organizations");
        if (!Array.isArray(res.data))
          throw new Error("Something went wrong. Please reload the page.");
        if (active) {
          dispatch({
            type: GET_ALL_ORGANISATIONS_SUCCESS,
            payload: res.data,
          });
        }
      } catch (e) {
        if (active) {
          dispatch({
            type: GET_ALL_ORGANISATIONS_FAILURE,
            payload: handleErrors(e),
          });
        }
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const handleCreateMembership = async (data) => {
    dispatch({
      type: SET_FORM_LOADING,
    });

    try {
      const {
        id,
        rate,
        buildingId,
        type,
        name,
        endDate,
        startDate,
        lockingPeriod,
        annualEscalation,
        securityDeposit,
        workStationSeats,
        additionalServices,
        meetingRoomSeats,
        collabAreaSeats,
        onboardingCharges,
        exitCharges,
        totalDayPasses,
        meetingRoomCredits,
      } = data;

      let quantity = {
        workStationSeats,
        meetingRoomSeats,
        collabAreaSeats,
      };

      let formData = {
        id,
        organizationId: formState.organisation,
        name,
        rate,
        endDate,
        startDate,
        lockingPeriod,
        annualEscalation,
        securityDeposit,
        buildingId,
        type,
        additionalServices: additionalServices,
        quantity: quantity,
        onboardingCharges,
        exitCharges,
        totalNoOfDayPasses: totalDayPasses,
        meetingRoomCredits,
      };
      // dispatch({
      //   type: SET_FORM_LOADING,
      //   payload: true,
      // });
      console.log(formData);
      const res = await request.post("/memberships", formData);
      dispatch({
        type: FORM_SUBMIT_SUCCESS,
      });
      history.push(
        `/add-spoc/${res.data.membership._id}/${res.data.membership.name}`
      );
    } catch (e) {
      console.log(e);
      dispatch({
        type: FORM_SUBMIT_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  const handleOrganisationSelect = (event, value) => {
    dispatch({
      type: SET_ORGANISATION,
      payload: value._id,
    });
  };

  return (
    <div className="h-screen">
      <LoadingOverlay
        // className="h-screen"
        active={loading}
        spinner={loading}
        text="Loading please wait"
      >
        <div className="">
          <SectionHeader
            path={["dashboard", "add a new membership"]}
            title={"Add a New Membership"}
          />
          {/* Organisation Form */}

          <form
            onSubmit={handleSubmit(handleCreateMembership)}
            className="pb-24"
          >
            <div className="lg:px-32 px-8 mt-16">
              <div className="lg:flex">
                <div className="lg:mr-6 max-w-xs">
                  <h4 className="font-medium text-2xl leading-7">
                    Organisation Details
                  </h4>
                </div>
                <div className="w-full lg:mt-0 my-8">
                  {/* Autocomplete Organisation Search */}
                  <div className="md:w-1/2 w-full mb-6">
                    <label
                      className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                      htmlFor="center-location"
                    >
                      Select Existing Organisation
                    </label>
                    <Autocomplete
                      options={organisations}
                      getOptionLabel={(option) =>
                        option?.name || option?.registeredEmail
                      }
                      name="organisationSearch"
                      onChange={handleOrganisationSelect}
                      renderInput={(params) => (
                        <Input
                          params={params}
                          textFieldProps={{
                            placeholder: "Select An Organisation",
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>

              <hr className="border border-b-0 border-black mx-24 border-opacity-25" />
              {/* Membership Details Form */}
              {organisation && (
                <div className="lg:flex lg:py-16 py-8">
                  <div className="lg:mr-6 max-w-xs">
                    <h4 className="font-medium text-2xl leading-7">
                      Membership Details
                    </h4>
                  </div>

                  <div className="lg:mt-0 my-8 w-full">
                    <MembershipDetailsForm
                      membershipType={membershipType}
                      loadLocations={true}
                      getLocations={getLocations}
                      locations={formState.locations}
                      membershipTypes={formState.membershipTypes}
                    />
                    {/* Products Section Form*/}
                    <MembershipProducts membershipType={membershipType} />
                    <hr className="border b-2 mb-8" />
                    {/* Additional Services Form*/}
                    {membershipType !== "2gethr Connect" && (
                      <AdditionalServices
                        services={formState.additionalServices}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            {error && (
              <div className="error-footer">
                <ErrorFooter message={error} />
              </div>
            )}
            {organisation && (
              <div>
                <div className="shadow-lg bottom-0 w-full flex md:justify-end justify-center py-4 px-8 border border-b-2 items-center">
                  <button
                    disabled={loading}
                    type="submit"
                    className="bg-yellow-500 py-4 px-16 rounded font-bold text-sm tracking-widest leading-4 uppercase outline-none"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </LoadingOverlay>
    </div>
  );
};

const Input = ({ params, textFieldProps }) => (
  <div className="flex items-center" ref={params.InputProps.ref}>
    <div className="w-full">
      <input
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "4px",
          borderColor: "#cbd5e0",
          border: "1px solid #cbd5e0",
          outline: "none",
        }}
        type="text"
        {...params.inputProps}
        {...textFieldProps}
      />
    </div>
    <div className="-ml-8">
      <MdArrowDropDownCircle />
    </div>
  </div>
);

export default AddMembership;
